@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Vehicle Slider Drawer -->
<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="vhclSldrvisible"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="vhclSldrvisible = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedVehicle) {
    <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
    }
  </ng-container>
</nz-drawer>

<!-- Trip Slider Drawer -->
<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="trpSldrvisible"
  nzPlacement="right"
  nzTitle="Trip Dashboard"
  (nzOnClose)="trpSldrvisible = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedTrip) {
    <app-trips-slider [trip]="selectedTrip"></app-trips-slider>
    }
  </ng-container>
</nz-drawer>

<!-- Driver Slider Drawer -->
<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="driverSldrVisible"
  nzPlacement="right"
  nzTitle="Driver Profile"
  (nzOnClose)="driverSldrVisible = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedDriverForSlider) {
    <app-driver-slider [driver]="selectedDriverForSlider"></app-driver-slider>
    }
  </ng-container>
</nz-drawer>

<!-- Weighment Drawer -->
@if (wghmnts) {
<nz-drawer
  [nzClosable]="true"
  [nzWidth]="420"
  [nzVisible]="wghmnts"
  nzPlacement="right"
  nzTitle="Add Weighment Details"
  (nzOnClose)="closervrlst()"
>
  <ng-container *nzDrawerContent>
    <form nz-form [formGroup]="wghmntForm" class="space-y-4 p-2">
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Vehicle Number</label
          >
          <input
            nz-input
            formControlName="veh_nu"
            placeholder="Vehicle Number"
            class="w-full rounded-md"
            readonly
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Gross Weight (kg)</label
          >
          <input
            nz-input
            type="number"
            formControlName="grs_wght"
            (input)="calculate()"
            placeholder="Enter gross weight"
            class="w-full rounded-md"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Tare Weight (kg)</label
          >
          <input
            nz-input
            type="number"
            formControlName="tr_wght"
            (input)="calculate()"
            placeholder="Enter tare weight"
            class="w-full rounded-md"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Net Weight (kg)</label
          >
          <input
            nz-input
            formControlName="nt_wght"
            placeholder="Auto-calculated"
            class="w-full rounded-md bg-gray-50"
            readonly
          />
        </div>
      </div>
      <div class="flex gap-3 pt-4 border-t border-gray-200 mt-6">
        <button
          nz-button
          (click)="closervrlst()"
          nzType="default"
          class="flex-1 h-10 rounded-md"
        >
          Cancel
        </button>
        @if (wghmntForm.status == 'VALID') {
        <button
          nz-button
          (click)="updateWeighmnt()"
          nzType="primary"
          class="flex-1 h-10 rounded-md bg-teal-500 border-teal-500 hover:bg-teal-600"
        >
          Submit
        </button>
        }
      </div>
    </form>
  </ng-container>
</nz-drawer>
}

<!-- Brand Header - shown only on standalone /trips-dashboard route -->
@if (isStandalone) {
<div
  class="relative mb-2 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #ea580c 0%,
        #ea580c 40%,
        #7c3aed 40%,
        #7c3aed 100%
      );
    "
  ></div>
  <div
    class="flex items-center justify-between px-5 py-3 relative flex-wrap gap-2"
  >
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #ea580c, #c2410c);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(234, 88, 12, 0.25);
        "
      >
        <i
          nz-icon
          nzType="car"
          nzTheme="outline"
          style="font-size: 20px; color: #fff"
        ></i>
      </div>
      <div>
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          Daily Trips
        </h1>
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #ea580c;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            Trip Status & Management
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- Trips Section Header - Compact Fuellog Style -->
<div
  class="flex flex-wrap items-center justify-between"
  style="padding: 10px 14px; border-bottom: 1px solid #f3f4f6"
>
  <div class="flex items-center" style="gap: 10px">
    <div class="flex items-center" style="gap: 6px">
      <span
        style="
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #f97316;
          display: inline-block;
        "
      ></span>
      <span class="font-bold text-gray-800" style="font-size: 13px">{{
        trpsdata?.length || 0
      }}</span>
      <span class="text-gray-500 font-medium" style="font-size: 12px"
        >Trips</span
      >
    </div>
    <span
      style="
        width: 1px;
        height: 16px;
        background: #e5e7eb;
        display: inline-block;
      "
    ></span>
    <span class="text-gray-500 font-medium" style="font-size: 12px"
      >Daily Trips Status - {{ curTblDate }}</span
    >
    <span
      style="
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 2px 8px;
        border-radius: 9999px;
        font-size: 11px;
        font-weight: 600;
        background: #f0fdf4;
        color: #15803d;
      "
    >
      {{ completedTripsCount }} Completed
    </span>
  </div>
  <div class="flex flex-wrap items-center" style="gap: 8px">
    <!-- Search -->
    <div style="position: relative">
      <input
        type="text"
        [(ngModel)]="tripSearchText"
        placeholder="Search trips..."
        style="
          width: 180px;
          padding: 5px 10px 5px 30px;
          font-size: 12px;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          background: #f9fafb;
          outline: none;
        "
      />
      <svg
        style="
          position: absolute;
          left: 8px;
          top: 50%;
          transform: translateY(-50%);
          width: 14px;
          height: 14px;
          color: #9ca3af;
        "
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
        />
      </svg>
    </div>
    <!-- Filter Toggle -->
    <button
      (click)="filterPanelOpen = !filterPanelOpen"
      style="
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 5px 10px;
        font-size: 12px;
        font-weight: 500;
        border-radius: 6px;
        border: 1px solid #e5e7eb;
        cursor: pointer;
        transition: all 0.15s;
      "
      [style.background]="filterPanelOpen ? '#fff7ed' : '#f9fafb'"
      [style.color]="filterPanelOpen ? '#ea580c' : '#6b7280'"
      [style.borderColor]="filterPanelOpen ? '#fdba74' : '#e5e7eb'"
    >
      <i nz-icon nzType="filter" nzTheme="outline" style="font-size: 12px"></i>
      {{ filterPanelOpen ? "Hide" : "Filters" }}
    </button>
    <!-- Add Single Trip Button -->
    <button
      (click)="goToSchduleIntrfc()"
      style="
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 5px 12px;
        font-size: 12px;
        font-weight: 600;
        color: #ffffff;
        background: #ea580c;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.15s;
      "
      onmouseenter="this.style.background='#c2410c'"
      onmouseleave="this.style.background='#ea580c'"
    >
      <i nz-icon nzType="plus" style="font-size: 12px"></i>
      Single Trip
    </button>
    <!-- Add Multiple Trips Button -->
    <button
      (click)="goToprimaryTrps()"
      style="
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 5px 12px;
        font-size: 12px;
        font-weight: 600;
        color: #ffffff;
        background: #7c3aed;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.15s;
      "
      onmouseenter="this.style.background='#6d28d9'"
      onmouseleave="this.style.background='#7c3aed'"
    >
      <i nz-icon nzType="appstore" style="font-size: 12px"></i>
      Multiple Trips
    </button>
  </div>
</div>

<!-- Filters Section - Collapsible -->
@if (filterPanelOpen) {
<div
  style="
    padding: 10px 14px;
    border-bottom: 1px solid #f3f4f6;
    background: #fff7ed;
  "
>
  <div
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 items-end"
    style="gap: 12px"
  >
    <!-- Date Picker -->
    <div class="flex flex-col">
      <label
        style="
          font-size: 11px;
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 4px;
        "
        >Date</label
      >
      <nz-date-picker
        class="w-full"
        [nzDisabledDate]="disabledDate"
        [nzFormat]="dateFormat"
        [(ngModel)]="slctdDt"
        (ngModelChange)="onChange($event)"
      ></nz-date-picker>
    </div>
    <!-- ULB Select -->
    @if (tntLst.length > 1) {
    <div class="flex flex-col">
      <label
        style="
          font-size: 11px;
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 4px;
        "
        >ULB</label
      >
      <nz-select
        class="w-full"
        nzShowSearch
        [(ngModel)]="selectedtenant"
        nzPlaceHolder="Select ULB"
        (ngModelChange)="ontntSelect($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
        @for (t of tntLst; track t) {
        <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
        }
      </nz-select>
    </div>
    }
    <!-- Vendor Select -->
    @if (ShowClap) {
    <div class="flex flex-col">
      <label
        style="
          font-size: 11px;
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 4px;
        "
        >Vendor</label
      >
      <nz-select
        class="w-full"
        nzShowSearch
        [(ngModel)]="selectedvndr"
        (ngModelChange)="onvndrSelect($event)"
        nzPlaceHolder="Select Vendor"
        [ngModelOptions]="{ standalone: true }"
      >
        @for (v of vendorList; track v) {
        <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
        }
      </nz-select>
    </div>
    }
    <!-- Vehicle Select -->
    <div class="flex flex-col">
      <label
        style="
          font-size: 11px;
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 4px;
        "
        >Vehicle</label
      >
      <nz-select
        class="w-full"
        nzShowSearch
        [(ngModel)]="selectedVehicle"
        nzPlaceHolder="Select Vehicle"
        (ngModelChange)="selectVehicle($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        <nz-option [nzLabel]="'All Vehicles'" [nzValue]="0"></nz-option>
        @for (v of ttl_veh; track v) {
        <nz-option [nzLabel]="v.asrt_nm" [nzValue]="v.asrt_id"></nz-option>
        }
      </nz-select>
    </div>
  </div>
</div>
}

<!-- Trips Table Section -->
<div style="padding: 12px 14px">
  <app-data-grid
    class="driver-table overflow-hidden"
    style="width: 100%; border-radius: 8px; border: 1px solid #f3f4f6"
    [dataSource]="trpsdata"
    [legacyColumns]="tripsDatacolumnDefs"
    [searchPanel]="true"
    [filterRow]="false"
    [filterPanel]="false"
    [groupPanel]="false"
    [columnChooser]="true"
    [allowExport]="true"
    exportFileName="Trips Travelled Data"
    [pageSize]="10"
    [allowedPageSizes]="[10, 25, 50, 100]"
    [showPageSizeSelector]="true"
    [rowAlternationEnabled]="true"
    [showBorders]="false"
    [wordWrapEnabled]="true"
    (cellClick)="getSldr($event)"
    [cellPrepared]="bound_onCellPrepared"
  >
    <!-- Dynamic Columns from columnDefs -->

    <!-- Driver Column with Own/Hired Badge -->

    <app-grid-column
      dataField="crw_nm"
      caption="Driver"
      alignment="left"
      width="auto"
      cellTemplate="driverTemplate"
    ></app-grid-column>
    <ng-template appGridCell="driverTemplate" let-data="cell"
      ><div>
        <div class="flex items-center" style="gap: 6px">
          @if (data.data.crw_id) {
          <span
            class="cursor-pointer text-blue-600 hover:underline font-medium"
            (click)="
              getSldr({ data: data.data, column: { dataField: 'crw_nm' } })
            "
            >{{ data.data.crw_nm || "-" }}</span
          >
          } @if (!data.data.crw_id) {
          <span>{{ data.data.crw_nm || "-" }}</span>
          } @if (data.data.crw_own_in == 1) {
          <span
            class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-blue-100 text-blue-700"
            >Own</span
          >
          } @if (data.data.crw_own_in == 2) {
          <span
            class="px-1.5 py-0.5 text-[9px] font-semibold rounded bg-amber-100 text-amber-700"
            >Hired</span
          >
          }
        </div>
      </div></ng-template
    >

    <!-- Actions Column - Playback & Weighment -->

    <app-grid-column
      caption="Actions"
      [width]="120"
      alignment="center"
      cellTemplate="actionsTemplate"
    ></app-grid-column>
    <ng-template appGridCell="actionsTemplate" let-data="cell"
      ><div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
          "
        >
          <!-- Playback Button -->
          <button
            type="button"
            (click)="gotoPlaybck(data)"
            style="
              width: 30px;
              height: 30px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              border-radius: 6px;
              border: 1px solid #bfdbfe;
              background: #eff6ff;
              color: #2563eb;
              cursor: pointer;
              transition: all 0.15s;
            "
            onmouseenter="this.style.background='#dbeafe'; this.style.borderColor='#93c5fd'"
            onmouseleave="this.style.background='#eff6ff'; this.style.borderColor='#bfdbfe'"
            nz-tooltip
            nzTooltipTitle="Playback"
          >
            <svg
              style="width: 14px; height: 14px"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
              />
            </svg>
          </button>
          <!-- Weighment Button -->
          <button
            type="button"
            (click)="addWghmnt(data)"
            style="
              width: 30px;
              height: 30px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              border-radius: 6px;
              border: 1px solid #a7f3d0;
              background: #ecfdf5;
              color: #059669;
              cursor: pointer;
              transition: all 0.15s;
            "
            onmouseenter="this.style.background='#d1fae5'; this.style.borderColor='#6ee7b7'"
            onmouseleave="this.style.background='#ecfdf5'; this.style.borderColor='#a7f3d0'"
            nz-tooltip
            nzTooltipTitle="Add Weighment"
          >
            <svg
              style="width: 14px; height: 14px"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
              />
            </svg>
          </button>
        </div></div
    ></ng-template>
  </app-data-grid>
</div>
